import { Notification } from "@/components/ui/notification";

// The spec screens' failure message — the donor's `ErrorSnackbar`
// (`timmy/src/domains/specifications/shared/components/ErrorSnackbar.tsx`),
// ported as a shared component at first encounter because the donor shares it
// across the spec domain: every lifecycle dialog on the Spec list raises one,
// and the Editor's screens raise it next.
//
// It is react-ui's `Notification` at `severity='error'`, bottom centre, ten
// seconds:
//
// ```
// <Notification open severity='error'
//   anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//   autoHideDuration={10000} onClose={onClose}>{error}</Notification>
// ```
//
// — the shared `Notification`, so it keeps that component's rules: a standard
// alert with no close X, gone only when its clock runs out (neither a click
// elsewhere nor Escape dismisses it), portalled, and leaving at once.
//
// Not the items domain's `useItemsError`, which is a sonner toast: this donor's
// surface is a MUI `Snackbar` + `Alert`, the same pair as the Spec list's
// success snackbar beside it, so it draws with the same two shared components.

/** `autoHideDuration={10000}` (`ErrorSnackbar.tsx`). */
const ERROR_SNACKBAR_DURATION_MS = 10_000;

export interface ErrorSnackbarProps {
  open: boolean;
  message: string;
  /** The timer's close — in the donor, the failed mutation's `reset`. */
  onClose: () => void;
}

export function ErrorSnackbar({ open, message, onClose }: ErrorSnackbarProps) {
  return (
    <Notification
      open={open}
      severity="error"
      autoHideDuration={ERROR_SNACKBAR_DURATION_MS}
      onClose={onClose}
    >
      {message}
    </Notification>
  );
}
